import { useAuth } from '@/contexts/AuthContext'
import { useTenant } from '@/contexts'
import { useOrganizationProfile, useUpdateOrganizationProfile } from '@/hooks/useOrganizationProfile'
import { useTeamMembers } from '@/hooks/useTeamMembers'
import { OrganizationProfileForm } from '@/components/settings/organization'
import type { OrganizationProfileFormValues } from '@/components/settings/organization'

export function OrganizationSettingsPage() {
  const { user } = useAuth()
  const { currentOrganization } = useTenant()
  const { data: profile, isLoading } = useOrganizationProfile()
  const { mutate: updateProfile, isPending } = useUpdateOrganizationProfile()
  const { data: members = [] } = useTeamMembers()

  // Check if current user is owner
  const currentMember = members.find((m) => m.user_id === user?.id)
  const isOwner = currentMember?.role === 'owner'

  if (!currentOrganization) {
    return (
      <div className="p-6">
        <p className="text-gray-500">No organization selected</p>
      </div>
    )
  }

  const handleSubmit = (data: OrganizationProfileFormValues) => {
    if (!profile) return

    updateProfile({
      id: profile.id,
      data,
    })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Organization Settings</h1>
        <p className="text-gray-600 mt-2">
          Manage your organization's profile and settings
        </p>
      </div>

      <OrganizationProfileForm
        profile={profile || null}
        onSubmit={handleSubmit}
        isLoading={isLoading || isPending}
        isOwner={isOwner}
      />
    </div>
  )
}
